import { PropsWithChildren } from 'react';
import { Unit } from '../../components/Molecules/KpiWidget/KPIWidget.types';

export interface MetricData {
  kpi: KpiData[];
  breakdown: TimeSeriesData;
  description: string;
  label: string;
}

export interface KpiData {
  label?: string;
  value?: number;
  description?: string;
  unit?: Unit;
  id?: string;
}

export interface TimeSeriesDataPoint {
  label?: string;
  value?: number;
}

export interface TimeSeriesData {
  label?: string;
  values: TimeSeriesDataPoint[];
  description?: string;
  unit?: Unit;
  id?: KpiDataId;
}

export enum MetricIdEnum {
  chargerStatus = 'chargerStatus',
  totalChargingTime = 'totalChargingTime',
  energyDelivered = 'energyDelivered',
  avgChargingSession = 'avgChargingSession',
  avgStationUtilization = 'avgStationUtilization',
  chargingSessions = 'chargingSessions',
  newVsReturningDrivers = 'newVsReturningDrivers',
  revenue = 'revenue',
  electricMilesEnabled = 'electricMilesEnabled',
  iceEmissionsAvoided = 'iceEmissionsAvoided',
  timeBasedUtilization = 'timeBasedUtilization',
}

export enum MetricTypeEnum {
  total = 'total',
  time = 'time',
  previous = 'previous',
}

export enum WidgetType {
  KPI = 'kpi',
  DUAL_KPI = 'dualKpi',
  MAP = 'map',
  LINE_CHART = 'lineChart',
}
export interface MetricWidgetProps extends PropsWithChildren<any> {
  metricId: MetricIdEnum;
  type: WidgetType;
  previous?: boolean;
  animate?: boolean;
  locationIds?: string[];
  hasLocationFilter?: boolean;
}

export interface MetricVo {
  id: MetricIdEnum;
  name?: string;
  description?: string;
}

export interface IWidgetBase {
  title: string;
  animated: boolean;
  infoMessage: string;
  isLoading: boolean;
  error?: boolean;
}
export interface IUseWidgetByType {
  type: WidgetType;
  metricId: MetricIdEnum;
  animate?: boolean;
  metricData?: MetricData;
  previous?: boolean;
  isLoading: boolean;
  error?: boolean;
  hasLocationFilter?: boolean;
}

export enum KpiDataId {
  TOTAL_CURRENT = 'total_current',
  TOTAL_PREVIOUS = 'total_previous',
  TIMES_CURRENT = 'times_current',
  TIMES_PREVIOUS = 'times_previous',
}

export interface ILineChartConfig {
  yAxisLabel?: string;
  yAxisDomain?: [number | 'auto', number | 'auto'];
  xAxisLabel?: string;
  unit?: string;
  tooltipLabel?: string;
  emptyStateMessage?: string;
}
